"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceInvalidCharactersInSmsText = exports.getSmsCountFromText = exports.isAValidNumber = exports.nz = exports.isMfaRequiredResponse = void 0;
__exportStar(require("./interfaces"), exports);
__exportStar(require("./constants"), exports);
function isPlainRecord(v) {
    return typeof v === 'object' && v !== null;
}
/**
 *
 * @description Distingue la respuesta de `POST /auth/signin` que exige el
 * segundo factor (`{ mfa: { requires_mfa: true, session_temp } }`) de la
 * respuesta de login clásico (`UserAuthResponse`).
 * @param data cuerpo de la respuesta
 * @returns `true` solo si `data.mfa.requires_mfa === true` y
 * `data.mfa.session_temp` es string
 */
function isMfaRequiredResponse(data) {
    if (!isPlainRecord(data))
        return false;
    const { mfa } = data;
    if (!isPlainRecord(mfa))
        return false;
    return mfa.requires_mfa === true && typeof mfa.session_temp === 'string';
}
exports.isMfaRequiredResponse = isMfaRequiredResponse;
/**
 *
 * @description Replaces NaN values with zeros (or given value).
 * @param v value
 * @param d value to use if `v` is not valid
 */
function nz(v, d) {
    const notValid = !isAValidNumber(v);
    return notValid ? d !== null && d !== void 0 ? d : 0 : v;
}
exports.nz = nz;
function isAValidNumber(v) {
    return typeof v !== 'undefined' && v !== null && isFinite(+v) && !isNaN(+v);
}
exports.isAValidNumber = isAValidNumber;
/**
 *
 * @param text SMS text
 * @returns SMS count based on text length
 *
 */
function getSmsCountFromText(text) {
    return text.length <= 160 ? 1 : Math.ceil(text.length / 153);
}
exports.getSmsCountFromText = getSmsCountFromText;
function replaceInvalidCharactersInSmsText(text) {
    const invalidCharacters = /[^a-zñA-ZÑ0-9¡!"#$%&'()*+,\-./:;<=>¿?@[\]\\^_ ]/g;
    // prettier-ignore
    return Buffer.from(text).toString("utf8")
        .replace(new RegExp(['á', 'à', 'â', 'ã', 'ª', 'ä', 'å', 'ā', 'ă', 'ą', 'ǎ', 'ǟ', 'ǡ', 'ȧ', 'ǻ', 'ȁ', 'ȃ'].join("|"), "g"), 'a')
        .replace(new RegExp(['Á', 'À', 'Â', 'Ã', 'Ä', 'Å', 'Ā', 'Ă', 'Ą', 'Ǎ', 'Ǟ', 'Ǡ', 'Ȧ', 'Ǻ', 'Ȁ', 'Ȃ'].join("|"), "g"), 'A')
        .replace(new RegExp(['Í', 'Ì', 'Î', 'Ï', 'Ĩ', 'Ī', 'Ĭ', 'Į', 'İ', 'Ǐ', 'Ȉ', 'Ȋ'].join("|"), "g"), 'I')
        .replace(new RegExp(['í', 'ì', 'î', 'ï', 'ĩ', 'ī', 'ĭ', 'į', 'ı', 'ǐ', 'ȉ', 'ȋ'].join("|"), "g"), 'i')
        .replace(new RegExp(['É', 'È', 'Ê', 'Ë', 'Ē', 'Ĕ', 'Ė', 'Ę', 'Ě', 'Ȅ', 'Ȇ', 'Ȩ', 'Ɇ'].join("|"), "g"), 'E')
        .replace(new RegExp(['é', 'è', 'ê', 'ë', 'ē', 'ĕ', 'ė', 'ę', 'ě', 'ȅ', 'ȇ', 'ȩ', 'ɇ'].join("|"), "g"), 'e')
        .replace(new RegExp(['Ó', 'Ò', 'Ô', 'Õ', 'Ö', 'Ø', 'Ő', 'Ŏ', 'Ō', 'Ȫ', 'Ȭ', 'Ȯ', 'Ȱ', 'Ȏ', 'Ȍ', 'Ǒ', 'Ǿ'].join("|"), "g"), 'O')
        .replace(new RegExp(['ó', 'ò', 'ô', 'õ', 'ö', 'º', 'ø', 'ő', 'ŏ', 'ō', 'ȫ', 'ȭ', 'ȯ', 'ȱ', 'ȏ', 'ȍ', 'ǿ', 'ǒ'].join("|"), "g"), 'o')
        .replace(new RegExp(['Ú', 'Ù', 'Û', 'Ü', 'Ũ', 'Ū', 'Ŭ', 'Ȗ', 'Ȕ', 'Ų', 'Ű', 'Ů', 'Ǔ', 'Ǖ', 'Ǘ', 'Ǚ', 'Ǜ'].join("|"), "g"), 'U')
        .replace(new RegExp(['ú', 'ù', 'û', 'ü', 'ũ', 'ū', 'ŭ', 'ȗ', 'ȕ', 'ų', 'ű', 'ů', 'ǔ', 'ǖ', 'ǘ', 'ǚ', 'ǜ'].join("|"), "g"), 'u')
        .replace(new RegExp(['Ç', 'Ć', 'Ĉ', 'Ċ', 'Č'].join("|"), "g"), 'C')
        .replace(new RegExp(['ç', 'ĉ', 'ć', 'ċ', 'č'].join("|"), "g"), 'c')
        .replace(new RegExp(['Ð', 'Ď', 'Đ'].join("|"), "g"), 'D')
        .replace(new RegExp(['đ', 'ď'].join("|"), "g"), 'd')
        .replace(new RegExp(['Ý', 'Ȳ', 'Ÿ', 'Ŷ'].join("|"), "g"), 'Y')
        .replace(new RegExp(['ý', 'ÿ', 'ȳ', 'ŷ'].join("|"), "g"), 'y')
        .replace(new RegExp(['Ĝ', 'Ğ', 'Ġ', 'Ģ', 'Ǧ', 'Ǥ', 'Ǵ'].join("|"), "g"), 'G')
        .replace(new RegExp(['ĝ', 'ğ', 'ġ', 'ģ', 'ǧ', 'ǥ', 'ǵ'].join("|"), "g"), 'g')
        .replace(new RegExp(['Ĥ', 'Ħ', 'Ȟ'].join("|"), "g"), 'H')
        .replace(new RegExp(['ħ', 'ĥ', 'ȟ'].join("|"), "g"), 'h')
        .replace(new RegExp(['ĵ'].join("|"), "g"), 'j')
        .replace(new RegExp(['Ĵ'].join("|"), "g"), 'J')
        .replace(new RegExp(['Ǩ', 'Ķ'].join("|"), "g"), 'K')
        .replace(new RegExp(['ǩ', 'ķ'].join("|"), "g"), 'k')
        .replace(new RegExp(['Ĺ', 'Ļ', 'Ľ', 'Ŀ', 'Ł'].join("|"), "g"), 'L')
        .replace(new RegExp(['ĺ', 'ļ', 'ľ', 'ŀ', 'ł'].join("|"), "g"), 'l')
        .replace(new RegExp(['Ń', 'Ņ', 'Ŋ', 'Ň', 'Ǹ'].join("|"), "g"), 'N')
        .replace(new RegExp(['ń', 'ǹ', 'ŋ', 'ŉ', 'ň', 'ņ'].join("|"), "g"), 'n')
        .replace(new RegExp(['Ǭ', 'Ǫ'].join("|"), "g"), 'Q')
        .replace(new RegExp(['ǫ'].join("|"), "g"), 'q')
        .replace(new RegExp(['Ř', 'Ŗ', 'Ŕ', 'Ȓ', 'Ȑ'].join("|"), "g"), 'R')
        .replace(new RegExp(['ř', 'ŗ', 'ŕ', 'ȓ', 'ȑ'].join("|"), "g"), 'r')
        .replace(new RegExp(['Ś', 'Ŝ', 'Ş', 'Š', 'Ș'].join("|"), "g"), 'S')
        .replace(new RegExp(['ś', 'ŝ', 'ş', 'š', 'ș'].join("|"), "g"), 's')
        .replace(new RegExp(['Ţ', 'Ť', 'Ŧ', 'Ț'].join("|"), "g"), 'T')
        .replace(new RegExp(['ţ', 'ť', 'ŧ', 'ț'].join("|"), "g"), 't')
        .replace(new RegExp(['Ž', 'Ż', 'Ź', 'Ȥ'].join("|"), "g"), 'Z')
        .replace(new RegExp(['ž', 'ż', 'ź', 'ȥ'].join("|"), "g"), 'z')
        .replace(new RegExp(['Ŵ'].join("|"), "g"), 'W')
        .replace(new RegExp(['ŵ'].join("|"), "g"), 'w')
        // after cleaning up, replace any invalid character remaining
        .replace(invalidCharacters, "");
}
exports.replaceInvalidCharactersInSmsText = replaceInvalidCharactersInSmsText;
